export const FRONTEND = "https://medicaltourism-otwou.ondigitalocean.app";//production
export const SERVER = "https://www.mtm-server.com";//production
/* export const FRONTEND = "http://localhost:3000";//dev
export const SERVER = "http://localhost:4000";//dev */